import {CompassOutlined} from '@ant-design/icons';
import {Space, Typography} from 'antd';
import classNames from 'classnames';
import React from 'react';
import {useTranslation} from 'react-i18next';

import mockImage from '@/assets/images/Group-9645.png';

import styles from '../../../index.less';

const {Text} = Typography;

const MockLocationImg = () => {
  const {t} = useTranslation('company');
  return (
    <div style={{backgroundImage: `url(${mockImage})`}} className={classNames(styles.mockImageContainer, 'w-full flex rounded-t items-center')}>
      <span className={classNames(styles.mockImageText)}>
        <Space direction='vertical'>
          <CompassOutlined style={{fontSize: 20, color: '#a4a4a4'}} />
          <Text style={{color: '#a4a4a4', fontWeight: '500'}}>{t('company.noLocation')}</Text>
        </Space>
        
      </span>
    </div>
  );
};

export default MockLocationImg;